// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"d4e1744e","1249":"262b34bc","2017":"e8a7a256","3236":"e9026c52","3395":"0b21bfdc","6698":"e8a7a256","9588":"0b21bfdc"}[chunkId] + ".chunk.css";
};